import Keycloak from 'keycloak-js';

class AuthService {
    private readonly enabled: boolean;
    private readonly userId: string;
    private readonly keycloak: Keycloak | undefined;

    constructor(enabled: boolean, userId: string, keycloakInstance?: Keycloak) {
        this.enabled = enabled;
        this.userId = userId;
        this.keycloak = keycloakInstance;
    }

    async getToken(): Promise<string | undefined> {
        if (this.enabled && this.keycloak) {
            // Refresh token if it's about to expire
            try {
                await this.keycloak.updateToken(30);
                return this.keycloak.token;
            } catch (error) {
                console.error('Failed to refresh token', error);
                this.logout();
            }
        } else {
            return undefined;
        }
    }

    logout(): Promise<void> {
        if (this.enabled && this.keycloak) {
            return this.keycloak.logout();
        } else {
            console.log('Logout skipped (auth disabled)');
            return Promise.resolve();
        }
    }

    async getUserInfo(): Promise<Keycloak.KeycloakProfile | undefined> {
        if (this.enabled && this.keycloak) {
            return await this.keycloak.loadUserProfile();
        } else {
            return undefined;
        }
    }

    isEnabled(): boolean {
        return this.enabled;
    }

    getUserId(): string {
        return this.userId;
    }

    hasRole(role: string): boolean {
        return this.enabled && this.keycloak ? this.keycloak.hasRealmRole(role) : false;
    }

    login(): Promise<void> {
        if (this.enabled && this.keycloak) {
            return this.keycloak.login();
        } else {
            console.log('Login skipped (auth disabled)');
            return Promise.resolve();
        }
    }
}

export default AuthService;
